module.exports = __webpack_public_path__ + "static/media/RNG.97c4df02.svg";